import { render, staticRenderFns } from "./AutomaticMails.vue?vue&type=template&id=25d180fe"
import script from "./AutomaticMails.vue?vue&type=script&lang=js"
export * from "./AutomaticMails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports